import { NativeModules } from 'react-native';
import { AppleHKWorkoutActivityType } from 'fitbeat.models';
import { AuthorizationStatus, HREventListener } from '../connected-workout-app';

const { HealthKitManager } = NativeModules;
type OptionalString = string | null; // need to explicitly pass null to native

interface IHealthKit {
  isAvailable(): Promise<boolean>;
  requestAuthorization(): Promise<void>;
  workoutAuthorization(): Promise<AuthorizationStatus>;
  startWorkoutObserver(): Promise<void>;
  heartRateAuthorization(): Promise<AuthorizationStatus>;
  stopAndSaveWorkout(
    isoStartDate: string,
    isoEndDate: string,
    workoutDuration: number,
    workoutActivityType: AppleHKWorkoutActivityType,
    averageHeartRate: number,
    calories: number,
  ): Promise<string | void>;
  stopAndDiscardWorkout(): Promise<void>;
  prepareWorkout(
    userId: string,
    workoutActivityType: AppleHKWorkoutActivityType,
    startTime: OptionalString,
    endTime: OptionalString,
    startingZone: OptionalString,
    hrMetricsServerBaseUrl: OptionalString,
  ): Promise<void>;
  startWorkout(): Promise<void>;
  resumeWorkout(): Promise<void>;
  pauseWorkout(): Promise<void>;
  registerHREventHandler(listener: HREventListener): void;
  unRegisterHREventHandler(): void;
  isWatchAppInstalled(): Promise<boolean>;
  isWatchAppReachable(): Promise<boolean>;
  watchIsAvailable(): Promise<boolean>;
  sendTestMessage(message: string): Promise<boolean>;
}

export default HealthKitManager as IHealthKit;
